module.exports = __webpack_public_path__ + "img/e.962fba7d.jpg";